import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import { setWebEmpFetchter } from "../Filter/actions";
import {
  addWebEnquiryFailure,
  addWebEnquirySuccess,
  convertLeadFailure,
  convertLeadSuccess,
  deleteWebEnquiryFailure,
  deleteWebEnquirySuccess,
  editWebEnquiryFailure,
  editWebEnquirySuccess,
  fetchWebEnquiryFailure,
  fetchWebEnquirySuccess,
  getRefReportFailure,
  getRefReportSuccess,
  getReportFailure,
  getReportSuccess,
  getTypeReportFailure,
  getTypeReportSuccess,
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  setDigitalData,
  setRecommData,
  setAdvertData,
  setLocalData,
} from "./actions";
import {
  ADD_WEBENQUIRY,
  CONVERT_LEAD,
  DELETE_WEBENQ,
  EDIT_WEBENQUIRY,
  FETCH_WEBENQUIRY,
  GET_REF_REPORT,
  GET_REPORT,
  GET_TYPE_REPORT,
  GET_VIEW_DATA,
} from "./constants";

export function* fetchWebEnquirySaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/website-enquiry?${query}`
    );
    yield put(fetchWebEnquirySuccess(data));
    yield put(setWebEmpFetchter(true));
    typeof onSuccess === "function" && onSuccess();
  } catch (e) {
    yield put(fetchWebEnquiryFailure());
    yield put(setWebEmpFetchter(true));
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching list!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/website-enquiry/${payload}`
    );
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addWebEnquirySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/add/website-enquiry/dash`,
      payload?.data
    );

    if (data) {
      yield put(successAlert("Enquiry added successfully!"));
      yield put(addWebEnquirySuccess());
      if (payload?.history) {
        payload.history.goBack();
      }
    }
  } catch (e) {
    yield put(addWebEnquiryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editWebEnquirySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/website-enquiry/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Enquiry updated successfully!"));
      yield put(editWebEnquirySuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editWebEnquiryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteWebEnquirySaga({ payload, onDeleteSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).delete,
      `/api/website-enquiry/${payload}`
    );
    if (data) {
      yield put(successAlert("Enquiry deleted successfully!"));
      yield put(deleteWebEnquirySuccess());
      typeof onDeleteSuccess === "function" && onDeleteSuccess();
    }
  } catch (e) {
    yield put(deleteWebEnquiryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* convertLeadSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/convert-to-lead`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Enquiry converted to lead successfully!"));
      yield put(convertLeadSuccess());
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(convertLeadFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/web-graph-report?${query}`
    );
    if (data) {
      yield put(getReportSuccess(data));
    }
  } catch (e) {
    yield put(getReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getTypeReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload?.query) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/web-enquiry/referrer_type?${query}`
    );
    if (data) {
      yield put(getTypeReportSuccess(data));
    }
  } catch (e) {
    yield put(getTypeReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getRefReportSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.query ? QueryString.stringify(payload?.query) : "";
  const { refReport } = yield select((state) => state?.WebsiteEnquiriesReducer);

  let tempData = JSON.parse(JSON.stringify(refReport));
  let type = payload.type.replaceAll(" ", "");

  try {
    const { data } = yield call(
      api(token).get,
      `/api/web-enquiry-referrer-report/${payload.type}?${query}`
    );

    tempData[payload.type.replaceAll(" ", "")] = data ?? [];

    if (type === "Digital") {
      yield put(setDigitalData(data));
    }
    if (type === "Recommendation") {
      yield put(setRecommData(data));
    }
    if (type === "LocalReputation") {
      yield put(setLocalData(data));
    }
    if (type === "Advertising") {
      yield put(setAdvertData(data));
    }

    yield put(getRefReportSuccess(tempData));
  } catch (e) {
    yield put(getRefReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchWebEnquiryFlow() {
  yield takeEvery(FETCH_WEBENQUIRY, fetchWebEnquirySaga);
}
export function* addWebEnquiryFlow() {
  yield takeEvery(ADD_WEBENQUIRY, addWebEnquirySaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* editWebEnquiryFlow() {
  yield takeEvery(EDIT_WEBENQUIRY, editWebEnquirySaga);
}
export function* deleteWebEnquiryFlow() {
  yield takeEvery(DELETE_WEBENQ, deleteWebEnquirySaga);
}
export function* convertLeadFlow() {
  yield takeEvery(CONVERT_LEAD, convertLeadSaga);
}
export function* getReportFlow() {
  yield takeEvery(GET_REPORT, getReportSaga);
}
export function* getTypeReportFlow() {
  yield takeEvery(GET_TYPE_REPORT, getTypeReportSaga);
}
export function* getRefReportFlow() {
  yield takeEvery(GET_REF_REPORT, getRefReportSaga);
}

export default function* WebsiteEnquiriesSaga() {
  yield all([
    fetchWebEnquiryFlow(),
    addWebEnquiryFlow(),
    getViewDataFlow(),
    editWebEnquiryFlow(),
    deleteWebEnquiryFlow(),
    convertLeadFlow(),
    getReportFlow(),
    getTypeReportFlow(),
    getRefReportFlow(),
  ]);
}
